// Translated book names by language code
const BOOK_NAMES_I18N = {
  es: {
    "Genesis": "G\u00e9nesis", "Exodus": "\u00c9xodo", "Leviticus": "Lev\u00edtico", "Numbers": "N\u00fameros",
    "Deuteronomy": "Deuteronomio", "Joshua": "Josu\u00e9", "Judges": "Jueces", "Ruth": "Rut",
    "1 Samuel": "1 Samuel", "2 Samuel": "2 Samuel", "1 Kings": "1 Reyes", "2 Kings": "2 Reyes",
    "1 Chronicles": "1 Cr\u00f3nicas", "2 Chronicles": "2 Cr\u00f3nicas", "Ezra": "Esdras",
    "Nehemiah": "Nehem\u00edas", "Esther": "Ester", "Job": "Job", "Psalm": "Salmos",
    "Proverbs": "Proverbios", "Ecclesiastes": "Eclesiast\u00e9s",
    "Song of Solomon": "Cantares", "Isaiah": "Isa\u00edas", "Jeremiah": "Jerem\u00edas",
    "Lamentations": "Lamentaciones", "Ezekiel": "Ezequiel", "Daniel": "Daniel",
    "Hosea": "Oseas", "Joel": "Joel", "Amos": "Am\u00f3s", "Obadiah": "Abd\u00edas",
    "Jonah": "Jon\u00e1s", "Micah": "Miqueas", "Nahum": "Nah\u00fam", "Habakkuk": "Habacuc",
    "Zephaniah": "Sofon\u00edas", "Haggai": "Hageo", "Zechariah": "Zacar\u00edas",
    "Malachi": "Malaqu\u00edas", "Matthew": "Mateo", "Mark": "Marcos", "Luke": "Lucas",
    "John": "Juan", "Acts": "Hechos", "Romans": "Romanos",
    "1 Corinthians": "1 Corintios", "2 Corinthians": "2 Corintios",
    "Galatians": "G\u00e1latas", "Ephesians": "Efesios", "Philippians": "Filipenses",
    "Colossians": "Colosenses", "1 Thessalonians": "1 Tesalonicenses",
    "2 Thessalonians": "2 Tesalonicenses", "1 Timothy": "1 Timoteo",
    "2 Timothy": "2 Timoteo", "Titus": "Tito", "Philemon": "Filem\u00f3n",
    "Hebrews": "Hebreos", "James": "Santiago", "1 Peter": "1 Pedro",
    "2 Peter": "2 Pedro", "1 John": "1 Juan", "2 John": "2 Juan",
    "3 John": "3 Juan", "Jude": "Judas", "Revelation": "Apocalipsis",
  },
  fr: {
    "Genesis": "Gen\u00e8se", "Exodus": "Exode", "Leviticus": "L\u00e9vitique", "Numbers": "Nombres",
    "Deuteronomy": "Deut\u00e9ronome", "Joshua": "Josu\u00e9", "Judges": "Juges", "Ruth": "Ruth",
    "1 Samuel": "1 Samuel", "2 Samuel": "2 Samuel", "1 Kings": "1 Rois", "2 Kings": "2 Rois",
    "1 Chronicles": "1 Chroniques", "2 Chronicles": "2 Chroniques", "Ezra": "Esdras",
    "Nehemiah": "N\u00e9h\u00e9mie", "Esther": "Esther", "Job": "Job", "Psalm": "Psaumes",
    "Proverbs": "Proverbes", "Ecclesiastes": "Eccl\u00e9siaste",
    "Song of Solomon": "Cantique des Cantiques", "Isaiah": "\u00c9sa\u00efe", "Jeremiah": "J\u00e9r\u00e9mie",
    "Lamentations": "Lamentations", "Ezekiel": "\u00c9z\u00e9chiel", "Daniel": "Daniel",
    "Hosea": "Os\u00e9e", "Joel": "Jo\u00ebl", "Amos": "Amos", "Obadiah": "Abdias",
    "Jonah": "Jonas", "Micah": "Mich\u00e9e", "Nahum": "Nahum", "Habakkuk": "Habacuc",
    "Zephaniah": "Sophonie", "Haggai": "Agg\u00e9e", "Zechariah": "Zacharie",
    "Malachi": "Malachie", "Matthew": "Matthieu", "Mark": "Marc", "Luke": "Luc",
    "John": "Jean", "Acts": "Actes", "Romans": "Romains",
    "1 Corinthians": "1 Corinthiens", "2 Corinthians": "2 Corinthiens",
    "Galatians": "Galates", "Ephesians": "\u00c9ph\u00e9siens", "Philippians": "Philippiens",
    "Colossians": "Colossiens", "1 Thessalonians": "1 Thessaloniciens",
    "2 Thessalonians": "2 Thessaloniciens", "1 Timothy": "1 Timoth\u00e9e",
    "2 Timothy": "2 Timoth\u00e9e", "Titus": "Tite", "Philemon": "Phil\u00e9mon",
    "Hebrews": "H\u00e9breux", "James": "Jacques", "1 Peter": "1 Pierre",
    "2 Peter": "2 Pierre", "1 John": "1 Jean", "2 John": "2 Jean",
    "3 John": "3 Jean", "Jude": "Jude", "Revelation": "Apocalypse",
  },
  pt: {
    "Genesis": "G\u00eanesis", "Exodus": "\u00caxodo", "Leviticus": "Lev\u00edtico", "Numbers": "N\u00fameros",
    "Deuteronomy": "Deuteron\u00f4mio", "Joshua": "Josu\u00e9", "Judges": "Ju\u00edzes", "Ruth": "Rute",
    "1 Samuel": "1 Samuel", "2 Samuel": "2 Samuel", "1 Kings": "1 Reis", "2 Kings": "2 Reis",
    "1 Chronicles": "1 Cr\u00f4nicas", "2 Chronicles": "2 Cr\u00f4nicas", "Ezra": "Esdras",
    "Nehemiah": "Neemias", "Esther": "Ester", "Job": "J\u00f3", "Psalm": "Salmos",
    "Proverbs": "Prov\u00e9rbios", "Ecclesiastes": "Eclesiastes",
    "Song of Solomon": "C\u00e2nticos", "Isaiah": "Isa\u00edas", "Jeremiah": "Jeremias",
    "Lamentations": "Lamenta\u00e7\u00f5es", "Ezekiel": "Ezequiel", "Daniel": "Daniel",
    "Hosea": "Os\u00e9ias", "Joel": "Joel", "Amos": "Am\u00f3s", "Obadiah": "Obadias",
    "Jonah": "Jonas", "Micah": "Miqu\u00e9ias", "Nahum": "Naum", "Habakkuk": "Habacuque",
    "Zephaniah": "Sofonias", "Haggai": "Ageu", "Zechariah": "Zacarias",
    "Malachi": "Malaquias", "Matthew": "Mateus", "Mark": "Marcos", "Luke": "Lucas",
    "John": "Jo\u00e3o", "Acts": "Atos", "Romans": "Romanos",
    "1 Corinthians": "1 Cor\u00edntios", "2 Corinthians": "2 Cor\u00edntios",
    "Galatians": "G\u00e1latas", "Ephesians": "Ef\u00e9sios", "Philippians": "Filipenses",
    "Colossians": "Colossenses", "1 Thessalonians": "1 Tessalonicenses",
    "2 Thessalonians": "2 Tessalonicenses", "1 Timothy": "1 Tim\u00f3teo",
    "2 Timothy": "2 Tim\u00f3teo", "Titus": "Tito", "Philemon": "Filemom",
    "Hebrews": "Hebreus", "James": "Tiago", "1 Peter": "1 Pedro",
    "2 Peter": "2 Pedro", "1 John": "1 Jo\u00e3o", "2 John": "2 Jo\u00e3o",
    "3 John": "3 Jo\u00e3o", "Jude": "Judas", "Revelation": "Apocalipse",
  },
};

/**
 * Get the localized display name for a Bible book.
 * @param {string} englishName - The English book name (internal key)
 * @param {string} langCode - Language code (e.g., 'es', 'fr', 'pt')
 * @returns {string} The localized name, or the English name as fallback
 */
export function getLocalizedBookName(englishName, langCode) {
  const lang = (langCode || 'en').split('-')[0];
  return BOOK_NAMES_I18N[lang]?.[englishName] || englishName;
}

// English aliases: common variations -> canonical BIBLE_BOOKS name
const ENGLISH_ALIASES = {
  "psalms": "Psalm",
  "song of songs": "Song of Solomon",
  "songs of solomon": "Song of Solomon",
  "revelations": "Revelation",
};

// Build reverse lookup: localized name -> English name (for all languages)
const _reverseMap = {};
for (const [, names] of Object.entries(BOOK_NAMES_I18N)) {
  for (const [eng, localized] of Object.entries(names)) {
    _reverseMap[localized.toLowerCase()] = eng;
  }
}

/**
 * Try to resolve a localized or variant book name back to its canonical English name.
 * Handles: localized names (Spanish, French, Portuguese), common English aliases (Psalms, Revelations).
 * Returns the canonical name if found, or the input as-is.
 */
export function resolveToEnglishBookName(name) {
  if (!name) return name;
  const lower = name.toLowerCase();
  return ENGLISH_ALIASES[lower] || _reverseMap[lower] || name;
}

export const BIBLE_BOOKS = [
  { name: "Genesis", chapters: [31, 25, 24, 26, 32, 22, 24, 22, 29, 32, 32, 20, 18, 24, 21, 16, 27, 33, 38, 18, 34, 24, 20, 67, 34, 35, 46, 22, 35, 43, 55, 32, 20, 31, 29, 43, 36, 30, 23, 23, 57, 38, 34, 34, 28, 34, 31, 22, 33, 26] },
  { name: "Exodus", chapters: [22, 25, 22, 31, 23, 30, 25, 32, 35, 29, 10, 51, 22, 31, 27, 36, 16, 27, 25, 26, 36, 31, 33, 18, 40, 37, 21, 43, 46, 38, 18, 35, 23, 35, 35, 38, 29, 31, 43, 38] },
  { name: "Leviticus", chapters: [17, 16, 17, 35, 19, 30, 38, 36, 24, 20, 47, 8, 59, 57, 33, 34, 16, 30, 37, 27, 24, 33, 44, 23, 55, 46, 34] },
  { name: "Numbers", chapters: [54, 34, 51, 49, 31, 27, 89, 26, 23, 36, 35, 16, 33, 45, 41, 50, 13, 32, 22, 29, 35, 41, 30, 25, 18, 65, 23, 31, 40, 16, 54, 42, 56, 29, 34, 13] },
  { name: "Deuteronomy", chapters: [46, 37, 29, 49, 33, 25, 26, 20, 29, 22, 32, 32, 18, 29, 23, 22, 20, 22, 21, 20, 23, 30, 25, 22, 19, 19, 26, 68, 29, 20, 30, 52, 29, 12] },
  { name: "Joshua", chapters: [18, 24, 17, 24, 15, 27, 26, 35, 27, 43, 23, 24, 33, 15, 63, 10, 18, 28, 51, 9, 45, 34, 16, 33] },
  { name: "Judges", chapters: [36, 23, 31, 24, 31, 40, 25, 35, 57, 18, 40, 15, 25, 20, 20, 31, 13, 31, 30, 48, 25] },
  { name: "Ruth", chapters: [22, 23, 18, 22] },
  { name: "1 Samuel", chapters: [28, 36, 21, 22, 12, 21, 17, 22, 27, 27, 15, 25, 23, 52, 35, 23, 58, 30, 24, 42, 15, 23, 29, 22, 44, 25, 12, 25, 11, 31, 13] },
  { name: "2 Samuel", chapters: [27, 32, 39, 12, 25, 23, 29, 18, 13, 19, 27, 31, 39, 33, 37, 23, 29, 33, 43, 26, 22, 51, 39, 25] },
  { name: "1 Kings", chapters: [53, 46, 28, 34, 18, 38, 51, 66, 28, 29, 43, 33, 34, 31, 34, 34, 24, 46, 21, 43, 29, 53] },
  { name: "2 Kings", chapters: [18, 25, 27, 44, 27, 33, 20, 29, 37, 36, 21, 21, 25, 29, 38, 20, 41, 37, 37, 21, 26, 20, 37, 20, 30] },
  { name: "1 Chronicles", chapters: [54, 55, 24, 43, 26, 81, 40, 40, 44, 14, 47, 40, 14, 17, 29, 43, 27, 17, 19, 8, 30, 19, 32, 31, 31, 32, 34, 21, 30] },
  { name: "2 Chronicles", chapters: [17, 18, 17, 22, 14, 42, 22, 18, 31, 19, 23, 16, 22, 15, 19, 14, 19, 34, 11, 37, 20, 12, 21, 27, 28, 23, 9, 27, 36, 27, 21, 33, 25, 33, 27, 23] },
  { name: "Ezra", chapters: [11, 70, 13, 24, 17, 22, 28, 36, 15, 44] },
  { name: "Nehemiah", chapters: [11, 20, 32, 23, 19, 19, 73, 18, 38, 39, 36, 47, 31] },
  { name: "Esther", chapters: [22, 23, 15, 17, 14, 14, 10, 17, 32, 3] },
  { name: "Job", chapters: [22, 13, 26, 21, 27, 30, 21, 22, 35, 22, 20, 25, 28, 22, 35, 22, 16, 21, 29, 29, 34, 30, 17, 25, 6, 14, 23, 28, 25, 31, 40, 22, 33, 37, 16, 33, 24, 41, 30, 24, 34, 17] },
  { name: "Psalm", chapters: [6, 12, 8, 8, 12, 10, 17, 9, 20, 18, 7, 8, 6, 7, 5, 11, 15, 50, 14, 9, 13, 31, 6, 10, 22, 12, 14, 9, 11, 12, 24, 11, 22, 22, 28, 12, 40, 22, 13, 17, 13, 11, 5, 26, 17, 11, 9, 14, 20, 23, 19, 9, 6, 7, 23, 13, 11, 11, 17, 12, 8, 12, 11, 10, 13, 20, 7, 35, 36, 5, 24, 20, 28, 23, 10, 12, 20, 72, 13, 19, 16, 8, 18, 12, 13, 17, 7, 18, 52, 17, 16, 15, 5, 23, 11, 13, 12, 9, 9, 5, 8, 28, 22, 35, 45, 48, 43, 13, 31, 7, 10, 10, 9, 8, 18, 19, 2, 29, 176, 7, 8, 9, 4, 8, 5, 6, 5, 6, 8, 8, 3, 18, 3, 3, 21, 26, 9, 8, 24, 13, 10, 7, 12, 15, 21, 10, 20, 14, 9, 6] },
  { name: "Proverbs", chapters: [33, 22, 35, 27, 23, 35, 27, 36, 18, 32, 31, 28, 25, 35, 33, 33, 28, 24, 29, 30, 31, 29, 35, 34, 28, 28, 27, 28, 27, 33, 31] },
  { name: "Ecclesiastes", chapters: [18, 26, 22, 16, 20, 12, 29, 17, 18, 20, 10, 14] },
  { name: "Song of Solomon", chapters: [17, 17, 11, 16, 16, 13, 13, 14] },
  { name: "Isaiah", chapters: [31, 22, 26, 6, 30, 13, 25, 22, 21, 34, 16, 6, 22, 32, 9, 14, 14, 7, 25, 6, 17, 25, 18, 23, 12, 21, 13, 29, 24, 33, 9, 20, 24, 17, 10, 22, 38, 22, 8, 31, 29, 25, 28, 28, 25, 13, 15, 22, 26, 11, 23, 15, 12, 17, 13, 12, 21, 14, 21, 22, 11, 12, 19, 12, 25, 24] },
  { name: "Jeremiah", chapters: [19, 37, 25, 31, 31, 30, 34, 22, 26, 25, 23, 17, 27, 22, 21, 21, 27, 23, 15, 18, 14, 30, 40, 10, 38, 24, 22, 17, 32, 24, 40, 44, 26, 22, 19, 32, 21, 28, 18, 16, 18, 22, 13, 30, 5, 28, 7, 47, 39, 46, 64, 34] },
  { name: "Lamentations", chapters: [22, 22, 66, 22, 22] },
  { name: "Ezekiel", chapters: [28, 10, 27, 17, 17, 14, 27, 18, 11, 22, 25, 28, 23, 23, 8, 63, 24, 32, 14, 49, 32, 31, 49, 27, 17, 21, 36, 26, 21, 26, 18, 32, 33, 31, 15, 38, 28, 23, 29, 49, 26, 20, 27, 31, 25, 24, 23, 35] },
  { name: "Daniel", chapters: [21, 49, 30, 37, 31, 28, 28, 27, 27, 21, 45, 13] },
  { name: "Hosea", chapters: [11, 23, 5, 19, 15, 11, 16, 14, 17, 15, 12, 14, 16, 9] },
  { name: "Joel", chapters: [20, 32, 21] },
  { name: "Amos", chapters: [15, 16, 15, 13, 27, 14, 17, 14, 15] },
  { name: "Obadiah", chapters: [21] },
  { name: "Jonah", chapters: [17, 10, 10, 11] },
  { name: "Micah", chapters: [16, 13, 12, 13, 15, 16, 20] },
  { name: "Nahum", chapters: [15, 13, 19] },
  { name: "Habakkuk", chapters: [17, 20, 19] },
  { name: "Zephaniah", chapters: [18, 15, 20] },
  { name: "Haggai", chapters: [15, 23] },
  { name: "Zechariah", chapters: [21, 13, 10, 14, 11, 15, 14, 23, 17, 12, 17, 14, 9, 21] },
  { name: "Malachi", chapters: [14, 17, 18, 6] },
  { name: "Matthew", chapters: [25, 23, 17, 25, 48, 34, 29, 34, 38, 42, 30, 50, 58, 36, 39, 28, 27, 35, 30, 34, 46, 46, 39, 51, 46, 75, 66, 20] },
  { name: "Mark", chapters: [45, 28, 35, 41, 43, 56, 37, 38, 50, 52, 33, 44, 37, 72, 47, 20] },
  { name: "Luke", chapters: [80, 52, 38, 44, 39, 49, 50, 56, 62, 42, 54, 59, 35, 35, 32, 31, 37, 43, 48, 47, 38, 71, 56, 53] },
  { name: "John", chapters: [51, 25, 36, 54, 47, 71, 53, 59, 41, 42, 57, 50, 38, 31, 27, 33, 26, 40, 42, 31, 25] },
  { name: "Acts", chapters: [26, 47, 26, 37, 42, 15, 60, 40, 43, 48, 30, 25, 52, 28, 41, 40, 34, 28, 41, 38, 40, 30, 35, 27, 27, 32, 44, 31] },
  { name: "Romans", chapters: [32, 29, 31, 25, 21, 23, 25, 39, 33, 21, 36, 21, 14, 23, 33, 27] },
  { name: "1 Corinthians", chapters: [31, 16, 23, 21, 13, 20, 40, 13, 27, 33, 34, 31, 13, 40, 58, 24] },
  { name: "2 Corinthians", chapters: [24, 17, 18, 18, 21, 18, 16, 24, 15, 18, 33, 21, 14] },
  { name: "Galatians", chapters: [24, 21, 29, 31, 26, 18] },
  { name: "Ephesians", chapters: [23, 22, 21, 32, 33, 24] },
  { name: "Philippians", chapters: [30, 30, 21, 23] },
  { name: "Colossians", chapters: [29, 23, 25, 18] },
  { name: "1 Thessalonians", chapters: [10, 20, 13, 18, 28] },
  { name: "2 Thessalonians", chapters: [12, 17, 18] },
  { name: "1 Timothy", chapters: [20, 15, 16, 16, 25, 21] },
  { name: "2 Timothy", chapters: [18, 26, 17, 22] },
  { name: "Titus", chapters: [16, 15, 15] },
  { name: "Philemon", chapters: [25] },
  { name: "Hebrews", chapters: [14, 18, 19, 16, 14, 20, 28, 13, 28, 39, 40, 29, 25] },
  { name: "James", chapters: [27, 26, 18, 17, 20] },
  { name: "1 Peter", chapters: [25, 25, 22, 19, 14] },
  { name: "2 Peter", chapters: [21, 22, 18] },
  { name: "1 John", chapters: [10, 29, 24, 21, 21] },
  { name: "2 John", chapters: [13] },
  { name: "3 John", chapters: [14] },
  { name: "Jude", chapters: [25] },
  { name: "Revelation", chapters: [20, 29, 22, 11, 14, 17, 17, 13, 21, 11, 19, 17, 18, 20, 8, 21, 18, 24, 21, 15, 27, 21] },
];
